import { Tabs } from "antd";
import React from "react";

import DataContent from "./DataContent";

const InterBranchAdminDashboardDataTab = (props) => {
  const items = [
    {
      label: "Appointments – Confirmed",
      key: "conformed-appointments",
      children: <DataContent context="CONFORMED" {...props} />,
    },
    {
      label: "Appointments – Requests",
      key: "requested-appointments",
      children: <DataContent context="REQUESTS" {...props} />,
    },
  ];
  return (
    <div className="px-3 w-100">
      <Tabs items={items} className="w-100" />
    </div>
  );
};

export default InterBranchAdminDashboardDataTab;
